// queue_state -> badge presentation. Colours are reactstrap Badge `color` values; `outline` is the
// reactstrap `outline` flag (used for the spec's "success-outline").
const STATES = {
  awaiting_approval_hold_running: { hold: 'running', approval: 'Approval required', color: 'info' },
  awaiting_approval_hold_expired: { hold: 'Hold expired', approval: 'Awaiting approval', color: 'warning' },
  approved_hold_running: { hold: 'running', approval: 'approved', color: 'success', outline: true },
  approved_releasing: { hold: 'Releasing', approval: 'approved', color: 'success', outline: true },
  release_failed: { hold: 'Release failed', approval: 'approved', color: 'danger' },
  released: { hold: 'Released', approval: 'approved', color: 'secondary' },
  cancelled: { hold: 'Cancelled', approval: 'ifany', color: 'secondary' },
};

const AWAITING_STATES = ['awaiting_approval_hold_running', 'awaiting_approval_hold_expired'];

const timeLeft = (releaseAt) => {
  const ms = Math.max(0, new Date(releaseAt).getTime() - Date.now());
  const totalMinutes = Math.floor(ms / 60000) || 0;
  return `${Math.floor(totalMinutes / 60)}h ${totalMinutes % 60}m left`;
};

// Applied on each render (nothing ticks, and it uses the viewer's clock): a running hold whose
// release time has passed by then shows as expired instead of "0h 0m left".
const EXPIRED_STATE = {
  awaiting_approval_hold_running: 'awaiting_approval_hold_expired',
  approved_hold_running: 'approved_releasing',
};

export const effectiveQueueState = (row) => {
  const next = EXPIRED_STATE[row?.queue_state];
  return next && new Date(row.release_at).getTime() <= Date.now() ? next : row?.queue_state;
};

export const queueStatePresentation = (row) => {
  const state = effectiveQueueState(row);
  const s = STATES[state] || { hold: state || '', approval: 'ifany', color: 'secondary' };
  const approved = row?.approved_by ? `Approved by ${row.approved_by}` : '';
  return {
    holdLabel: s.hold === 'running' ? `Hold running (${timeLeft(row.release_at)})` : s.hold,
    holdColor: s.color,
    holdOutline: !!s.outline,
    // A hold that never needed approval (a failed one on a deleted program) must not read as approved.
    // An approved state otherwise always shows a pill, even if the approver's user row is gone.
    approvalLabel: row?.requires_approval === false
      ? 'Not required'
      : ({ approved: approved || 'Approved', ifany: approved }[s.approval] ?? s.approval),
    approvalColor: row?.requires_approval === false ? 'secondary' : s.color,
    approvalOutline: row?.requires_approval === false ? false : !!s.outline,
  };
};

export const canApprove = (row) => AWAITING_STATES.includes(row?.queue_state);

export const STATE_FILTER_OPTIONS = [
  { value: 'pending', label: 'Pending' },
  { value: 'awaiting_approval_hold_expired', label: 'Awaiting approval – hold expired' },
  { value: 'awaiting_approval_hold_running', label: 'Awaiting approval – hold running' },
  { value: 'approved_hold_running', label: 'Approved – hold running' },
  { value: 'approved_releasing', label: 'Approved – releasing' },
  { value: 'release_failed', label: 'Release failed' },
  { value: 'released', label: 'Released' },
  { value: 'cancelled', label: 'Cancelled' },
  { value: 'all', label: 'All' },
];

export const HOLD_STATUS_LABELS = {
  held: 'Held',
  released: 'Released',
  cancelled: 'Cancelled',
  failed: 'Release failed',
};

export const HOLD_SOURCE_LABELS = {
  card_deposit: 'Card deposit',
  invoice_payment: 'Invoice payment',
  program_payment: 'Program payment',
};
